/* A single-series column chart (the dataviz conventions): one token hue, bars at most 24px
   wide with 4px rounded ends from a hairline baseline, text in text tokens, never the bar
   colour. Tokens only, so every theme and dark mode follow. */

.figure {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  margin: 0;
}

.caption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  color: var(--graphite);
  font: var(--t-small);
}

.readout {
  min-height: 18px;
  margin: 0;
  color: var(--ink);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.plot {
  display: flex;
  align-items: stretch;
  gap: var(--space-1);
  height: 140px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.slot {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  border-radius: var(--radius-tag);
  cursor: default;
}

.slot:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.track {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  border-bottom: 1px solid var(--border);
}

.bar {
  display: block;
  width: 100%;
  max-width: 24px;
  min-height: 2px;
  border-radius: 4px 4px 0 0;
  background: var(--color-primary);
}

/* A zero is a value, drawn as a hairline on the baseline so it differs from "no data". */
.bar[data-zero='true'] {
  min-height: 1px;
  background: var(--border-strong);
}

.slot[data-active='true'] .bar {
  background: var(--color-primary-hover);
}

.tip {
  margin-bottom: var(--space-1);
  color: var(--ink);
  font: var(--t-micro);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.axis {
  padding-top: var(--space-1);
  overflow: hidden;
  color: var(--graphite);
  font: var(--t-micro);
  text-overflow: ellipsis;
  white-space: nowrap;
}
